import { CHAT, SETTINGS_INDEX, STUDIO } from "./routes";

export const mobileNavBarRoutes = [CHAT, STUDIO, SETTINGS_INDEX];
